import styles from './SmartMeterOption.module.scss'
import { Card, Heading, Icon, InlineMessage, Switch, Tag } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import { SmartMeterOptionProps } from 'pages/app/addresses/offtake-address/components/smart-meter-option/types'
import classNames from 'classnames'
import { SmartMeterStatus } from '../../types'

const SmartMeterOption = ({
  option,
  icon,
  status,
  readMoreUrl,
  editable,
  onChange,
  title,
  isDisabled,
  changeDueDate
}: SmartMeterOptionProps) => {
  // i18n
  const { t } = useTranslation('addresses')

  // Constants
  const disabledClassName = isDisabled ? 'text-subdued' : undefined

  return (
    <Card className={classNames(styles.item, styles[option], isDisabled && styles.disabled)}>
      {icon}

      <div className={styles.content}>
        <Heading as="h3" variant="h5" className={disabledClassName}>
          {title}
        </Heading>
        <p className={disabledClassName}>{t(($) => $.myContract.smartMeterOptions[option].description)}</p>
        {readMoreUrl && !isDisabled && (
          <a href={readMoreUrl} target="_blank" rel="noreferrer noopener" className={styles['more-info']}>
            {t(($) => $.readMore, {
              ns: 'common'
            })}{' '}
            <Icon name="externalLink" />
          </a>
        )}
        {changeDueDate && (
          <InlineMessage type="neutral" className={classNames(disabledClassName, 'mt-200')}>
            {t(($) => $.myContract.smartMeterOptions.pendingChange.title, {
              date: changeDueDate,
              interpolation: { escapeValue: false }
            })}
          </InlineMessage>
        )}
      </div>

      <div className={styles.status}>
        {editable ? (
          <div className={styles['switch-group']}>
            <span>
              {status === SmartMeterStatus.ACTIVE
                ? t(($) => $.myContract.smartMeterOptions.status.active)
                : t(($) => $.myContract.smartMeterOptions.status.inactive)}
            </span>
            <Switch checked={status === SmartMeterStatus.ACTIVE} onChange={(event) => onChange(event.target.checked)} />
          </div>
        ) : (
          <Tag type={status === SmartMeterStatus.ACTIVE ? 'positive' : status === SmartMeterStatus.PENDING ? 'warning' : 'neutral'}>
            {t(
              ($) =>
                $.myContract.smartMeterOptions.status[
                  status === SmartMeterStatus.ACTIVE ? 'active' : status === SmartMeterStatus.PENDING ? 'pending' : 'inactive'
                ]
            )}
          </Tag>
        )}
      </div>
    </Card>
  )
}

export default SmartMeterOption
